export default {"src":"//_next/static/media/rainbow.0adaea0a.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};